import WeatherGlyph from './WeatherGlyph';
import { labelFor, rainWorthSaying, type Hour } from '../lib/weather';
import { fmtTime } from '../lib/time';

/**
 * Hours as a vertical list. **One caller: the Schedule's rail card** (D67).
 *
 * It was extracted to be shared with the pill's panel on Now, and then was
 * not: the panel took `WeatherHourStrip` instead, because Videet wanted the
 * weather scrolled sideways rather than stacked, and a twelve-row table there
 * would have been taller than the event card it opens above. The rail keeps
 * this one — it has a 420px column, so it can afford a row per hour and the
 * room to spell "Thunderstorm" out, which the strip's 40px cells cannot.
 *
 * Still its own file rather than inlined back into `WeatherRail`, because the
 * two renderings of an hour now sit side by side and are easier to keep
 * honest when each is a named thing. The rain figure is printed only past
 * `RAIN_THRESHOLD` here exactly as in the strip, so a dry day is a clean
 * column of temperatures rather than a run of zeroes.
 *
 * Scrolls rather than growing: the longest day of the week is fourteen rows,
 * which would push the wardrobe planner off a laptop screen.
 */
export default function WeatherHourList({ hours, label }: { hours: Hour[]; label: string }) {
  return (
    <ul className="wx-hlist" aria-label={label}>
      {hours.map((hour) => (
        <li className="wx-hrow" key={hour.at}>
          <span className="wx-hrow-at">{fmtTime(hour.at)}</span>
          <span className="wx-hrow-glyph">
            <WeatherGlyph code={hour.code} isDay={hour.isDay} size={17} />
          </span>
          {/* The condition in words. Both callers have room for it where the
              phone's horizontal strip does not, and it is the difference
              between a picture of a cloud and knowing it is a thunderstorm. */}
          <span className="wx-hrow-label">{labelFor(hour.code)}</span>
          <span className="wx-hrow-temp">{hour.temp}°</span>
          <span className="wx-hrow-rain">
            {rainWorthSaying(hour) ? `${hour.rainChance}%` : ''}
          </span>
        </li>
      ))}
    </ul>
  );
}
